import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setGoHome } from "../../action/homeAction";




const HotelChangeConfirmPopup = (props) => {

    const { t } = props

    const getLocationChangePopUpMessage = () => {
        let room = localStorage.getItem("room");

        if (room && room !== "null") {
            return t('hotelSelector.popup_subHeading_if_login');
        }

        if (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            return t('hotelSelector.popup_subHeading_if_precheckin'); //todo in translation
        }
        return "";
    }

    const getCurrentHotelLocation =()=>{
        const hotelData= props.location_data.payload;
        console.log("hotelLocation data is ", hotelData);
        const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        console.log(current_hotel_code,"current_hotel_code")
        for( let regionData of hotelData ){
            for( let hotel of regionData.hotelList){
                if(hotel.hotelPropertyKey == current_hotel_code){
                    return hotel.hotelName;
                }
            }
        }
        // hotelData.forEach((regionData)=>{
        //     regionData.hotelList.forEach((hotel)=>{
        //         if(hotel.hotelPropertyKey == current_hotel_code){
        //             return hotel.hotelName;
        //         }
        //     })
        // })
    }

    return (
        <>
            {/* <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('hotelSelector.popup_heading')}</h2>
                                    <p>{getLocationChangePopUpMessage()}</p>
                                </div>
                                
                            </div>
                        </div>
                        

                        <div class="overlay-controls">
                            <button class="button" onClick={()=>{props.proceed()}}>{t('hotelSelector.popup_proceed')}</button>
                            <button onClick={()=>{props.close()}} class="button secondary">{t('hotelSelector.popup_close')}</button>
                        </div>
                    </div>
                </div>
            </section>  */}



            <section class="overlay-custom" style={{
                height: '100%',
                position: 'absolute',
                top: '0',
                width: '100%',
                background: 'rgba(0, 0, 0, 0.8)'
            }}>
                <div class="overlay-window-container-custom custom-popup" id={"confirm-location-change"} style={{
                    display: 'flex',
                    flexDirection: "column",

                    justifyContent: 'space-between',
                    alignItems: 'center',
                    alignSelf: 'stretch',

                    borderBottom: '1px solid rgba(35, 31, 32, 0.10)'
                    , position: "fixed",
                    bottom: "0",
                    background: "white",
                    width: "100%",
                    borderRadius: "2rem 2rem 0rem 0rem"
                }}>
                    <div class="overlay-window-custom" style={{ marginBottom: "2rem" }}>
                        <div class="overlay-content padding-0" style={{ display: "flex", flexDirection: "column", padding: "1rem", alignItems: 'center' }}>

                            <div class="overlay-header" style={{
                                display: 'flex',
                                height: '56px',
                                padding: '0px 16px 0px 24px',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                alignSelf: 'stretch',
                                alignItems: "center",
                                borderBottom: "1px solid rgba(35, 31, 32, 0.10)"
                            }}>
                                <div class="overlay-header-title"  >
                                    <p>Change location</p>

                                </div>
                                <div class="close-button" onClick={() => { props.close() }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M15 5L5 15M5 5L15 15" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>

                            <div class="overlay-body-custom" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginBottom: "48px",
                                alignSelf: 'stretch'
                            }}>
                                <p class="heading" >Are you sure you want to change location?</p>
                                <p class="subHeading">{getLocationChangePopUpMessage()}</p>
                            </div>
                            <div class="overlay-controls-custom" style={{
                                display: 'flex',
                                width: '345px',
                              
                                display:"flex",
                                flexDirection:"column",
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <button class="button primary"  onClick={() => {  props.setGoHome(true); props.close(); }} style={{
                                    display: 'flex',
                                    width: '345px',
                                    height: '48px',
                                    minWidth: '128px',
                                    padding: '0px 24px',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>{`Return to ${getCurrentHotelLocation()}`}</button>
                                <button class="button secondary" onClick={()=> {props.proceed(); props.close()}}>Continue and change location</button>
                            </div>

                        </div>
                    </div>

                </div>

            </section >


        </>


    )
}

 

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        afterLoginHotelSelectionState: state.store2.afterLoginHotelSelectionState,
        location_data: state.store2.location_data,
    }
}

export default connect(mapStateToProps, { sendAnalytics,setGoHome })(withTranslation('translations')(HotelChangeConfirmPopup));




